import { Link, useLocation } from 'react-router-dom';

import PropTypes from 'prop-types';

import { CELL_LINK } from '#globalComponents/Table/tableStyles';

import { companyPagePath } from '../../../utils/crmPaths';

const CrmCompanyLink = ({ companyId, contactId, backLabel, children }) => {
	const { pathname, search } = useLocation();
	return (
		<Link
			to={companyPagePath(companyId, { contactId })}
			state={{ backTo: { to: `${pathname}${search}`, label: backLabel } }}
			className={`${CELL_LINK} inline-block`}
			title="Im CRM öffnen"
		>
			{children}
		</Link>
	);
};

CrmCompanyLink.propTypes = {
	companyId: PropTypes.string.isRequired,
	/** Scrolls to and highlights this contact on the company page. */
	contactId: PropTypes.string,
	/** Label of the "back" button the company page shows for this origin. */
	backLabel: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
};

export default CrmCompanyLink;
